import VideoViewer from '@wandb/weave/components/Panel2/VideoViewer';
import {Tailwind} from '@wandb/weave/components/Tailwind';
import _ from 'lodash';
import * as React from 'react';
import {useEffect, useState} from 'react';

import {labelComponent, makeCaptions} from '../util/media';
import {InstrumentedCenteredWaveLoader as Loader} from './../components/utility/InstrumentedLoader';
import {MediaCardProps} from './MediaCard';
import MessageMediaNotFound from './MessageMediaNotFound';
import {SingleRunLink} from './MultiRunWorkspace/SingleRunMode';
import {useGetTrackingCallbacks} from './PanelMediaBrowser/MediaBrowserPanelTileTrackingContext';

type VideoCardProps = MediaCardProps;

// a single image card
const VideoCard = React.memo((props: VideoCardProps) => {
  const {
    run,
    mediaKey,
    mediaIndex,
    runSignature,
    globalStep,
    tileMedia,
    loading,
    customRunName,
    tileMediaSpec,
    getMediaTracking,
  } = props;
  const objectURL = tileMedia?.objectURL ?? '';
  const filename = tileMedia?.filePath
    ? _.last(tileMedia.filePath.split('/'))
    : undefined;

  const [refreshTimestamp, setRefreshTimestamp] = useState<number>(Date.now());

  const titleLink = (
    <SingleRunLink
      {...runSignature}
      linkText={customRunName ?? run.displayName}
    />
  );

  // get captions for all images in the group
  const captions = makeCaptions(tileMedia?.historyRow[mediaKey], mediaIndex);

  useEffect(() => {
    setRefreshTimestamp(Date.now());
  }, [objectURL]);

  const loadingElement = <Loader name="panel-content-loader" size="small" />;

  const {trackSuccess, trackError} = useGetTrackingCallbacks(
    tileMedia,
    tileMediaSpec,
    getMediaTracking
  );

  return loading ? (
    loadingElement
  ) : (
    <Tailwind className="w-full px-2">
      <VideoViewer
        videoFilename={filename}
        videoSrc={objectURL}
        width={props.width}
        height={props.height}
        headerElement={labelComponent(props, tileMedia?.step, titleLink)}
        footerElement={
          captions.length > 0 ? (
            <div className="image-card-caption">{captions}</div>
          ) : undefined
        }
        failedLoadElement={
          <MessageMediaNotFound
            mediaIndex={mediaIndex}
            mediaKey={mediaKey}
            stepIndex={globalStep}
            mediaType="videos"
          />
        }
        loadingElement={loadingElement}
        refreshTimestamp={refreshTimestamp}
        mediaFailedToLoad={tileMedia == null}
        single={props.single}
        autoPlay={true}
        trackSuccess={trackSuccess}
        trackError={trackError}
      />
    </Tailwind>
  );
});

export default VideoCard;
